import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#757575",
      "fill-rule": "evenodd",
      d: "M7.83 5.779c0 .905-.689 1.638-1.767 1.638-1.036 0-1.725-.733-1.704-1.638-.021-.95.668-1.661 1.725-1.661s1.726.711 1.747 1.66m-3.384 13.48V8.71h3.278v10.547zM10.35 12.077c0-1.315-.042-2.437-.086-3.364h2.848l.15 1.445h.066c.431-.67 1.51-1.682 3.256-1.682 2.157 0 3.774 1.424 3.774 4.528v6.256H17.08v-5.845c0-1.36-.474-2.286-1.66-2.286-.906 0-1.445.625-1.66 1.228-.087.216-.13.518-.13.82v6.083h-3.278v-7.183z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }